import React from 'react';
import classNames from 'classnames';
import styles from './Layout.module.css';

export const SectionPaddingSide = ({ className, children }) => (
  <div className={classNames(styles.sectionPaddingSide, className)}>{children}</div>
);

export const SectionPaddingSideRedesign = ({ className, children }) => (
  <div className={classNames(styles.sectionPaddingSideRedesign, className)}>{children}</div>
);

export const SectionPaddingVertical = ({ className, children, style }) => (
  <div className={classNames(styles.sectionPaddingVertical, className)} style={style}>
    {children}
  </div>
);

export const ColumnCenter = ({ className, children, reverse, element: Element = 'div' }) => (
  <Element
    className={classNames(styles.columnCenter, reverse && styles.columnCenterReverse, className)}
  >
    {children}
  </Element>
);

export const SectionWidth = ({ className, ...props }) => (
  <SectionPaddingSideRedesign className={classNames(styles.sectionWidth, className)} {...props} />
);



// WEBPACK FOOTER //
// ./src/components/global/Layout/index.js